import { z } from "zod";
import { BillingInfoSchema } from "./auth.js";

export const PlanDtoSchema = z.object({
  code: z.string(),
  name: z.string(),
  days: z.number().int().nullable(),
  priceKurus: z.number().int(),
});
export type PlanDto = z.infer<typeof PlanDtoSchema>;

/** `consent`: ön bilgilendirme formu + mesafeli satış sözleşmesi onayı ve hizmetin hemen başlaması talebi (Yönetmelik m.15/1-ğ); ödeme kaydına yazılır. */
export const TransferBodySchema = z.object({ planCode: z.enum(["aylik", "yillik"]), consent: z.literal(true) });
export const CONTRACT_VERSION = "2026-09-19";

export const TransferResponseSchema = z.object({
  paymentId: z.string().uuid(),
  reference: z.string(),
  amountKurus: z.number().int(),
  planCode: z.string(),
  iban: z.string(),
  accountHolder: z.string(),
  instructions: z.string(),
});
export type TransferResponse = z.infer<typeof TransferResponseSchema>;

export const PaymentDtoSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  email: z.string().optional(),
  planCode: z.string(),
  amountKurus: z.number().int(),
  method: z.enum(["transfer", "iyzico"]),
  reference: z.string(),
  status: z.enum(["pending", "paid", "failed"]),
  note: z.string().nullable(),
  createdAt: z.string(),
  paidAt: z.string().nullable(),
  /** Yönetici listesinde: kullanıcının adı ve fatura bilgileri (fatura kesimi için) */
  userName: z.string().optional(),
  billing: BillingInfoSchema.nullable().optional(),
});
export type PaymentDto = z.infer<typeof PaymentDtoSchema>;

/** Sağlayıcı ayarlarının sunucu tarafında saklanan fatura/havale bölümü. */
export const BillingSettingsSchema = z.object({
  iban: z.string().default(""),
  accountHolder: z.string().default(""),
  transferNote: z.string().default("Açıklama alanına referans kodunu yazın; ödeme 1 iş günü içinde onaylanır."),
});
export type BillingSettings = z.infer<typeof BillingSettingsSchema>;

export const formatTl = (kurus: number): string =>
  `${(kurus / 100).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺`;
